import { render, staticRenderFns } from "./ServicePricelistCard.vue?vue&type=template&id=002f652e"
import script from "./ServicePricelistCard.vue?vue&type=script&lang=js"
export * from "./ServicePricelistCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports